export default "__VITE_ASSET__05224bef__"